import { createClient, type SupabaseClient } from "@supabase/supabase-js";

function supabaseEnv(): Partial<ImportMetaEnv> {
  return (import.meta as ImportMeta & { env?: Partial<ImportMetaEnv> }).env ?? {};
}

const url = supabaseEnv().VITE_SUPABASE_URL?.trim();
const anonKey = supabaseEnv().VITE_SUPABASE_ANON_KEY?.trim();

/**
 * Values come from `import.meta.env` as set in `ui/vite.config.ts`: either
 * `VITE_SUPABASE_*` / `ui/.env`, or mapped from the repo root `.env`
 * (`SUPABASE_URL`, `SUPABASE_PUBLISHABLE_KEY` or `SUPABASE_ANON_KEY`). We never
 * throw at import time so the sign-in page can show a configuration hint.
 */
export const isSupabaseConfigured: boolean = Boolean(url && anonKey);

export const supabase: SupabaseClient | null = isSupabaseConfigured
  ? createClient(url!, anonKey!, {
      auth: {
        flowType: "pkce",
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
        // Avoid cross-tab navigator.locks stalls on cold tab open (supabase-js ≥2.107 default).
        lock: async (_name, _acquireTimeout, fn) => fn(),
      },
    })
  : null;
